
/*
  This file is auto-generated and ignored by git.
  See the jsdocs-related scripts in package.json and pregenerate.js
*/

export default {
  "KButtonWithDropdownTest": {
    "displayName": "KButtonWithDropdownTest",
    "exportName": "default",
    "description": "",
    "tags": {},
    "sourceFiles": [
      "/opt/build/repo/lib/buttons-and-links/__tests__/components/KButtonWithDropdownTest.vue"
    ]
  },
  "KButton": {
    "exportName": "default",
    "displayName": "KButton",
    "description": "The KButton component is used to trigger actions",
    "tags": {},
    "props": [
      {
        "name": "text",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearance",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button appearance: `'raised-button'`, `'flat-button'`, or `'basic-link'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'raised-button'"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Overrides that will modify the styles sent to `$computedClass` based on `appearance` prop",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "primary",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Show as primary rather than secondary style\n(for `'raised-button'` and `'flat-button'` appearance)",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not button is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "type",
        "description": "HTML button `type` attribute (e.g. `'submit'`, `'reset'`)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'button'"
        }
      },
      {
        "name": "hasDropdown",
        "description": "Adds a dropdown arrow",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "icon",
        "description": "If provided, prepends a `KIcon` to the text in the button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "If provided, appends an `KIcon` to the text in the button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "click",
        "description": "Emitted when the button is triggered",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "icon"
      },
      {
        "name": "menu",
        "description": "Pass sub-components into the button, typically `KDropdownMenu`"
      },
      {
        "name": "default",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "iconAfter",
        "description": "Slot alternative to the `iconAfter` prop"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/buttons-and-links/KButton.vue",
      "/opt/build/repo/lib/buttons-and-links/buttonMixin.js"
    ]
  },
  "KButtonGroup": {
    "displayName": "KButtonGroup",
    "description": "Used to create a consistently spaced horizontal set of buttons and/or links.\n\nKButtonGroup works with KButton, KIconButton, KRouterLink, KExternalLink,\nand any <a> or <button> tags in its default slot.",
    "tags": {},
    "exportName": "default",
    "slots": [
      {
        "name": "default"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/buttons-and-links/KButtonGroup.vue"
    ]
  },
  "KExternalLink": {
    "exportName": "default",
    "displayName": "KExternalLink",
    "description": "KExternalLink creates a styled external link",
    "tags": {},
    "props": [
      {
        "name": "text",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearance",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button appearance: `'raised-button'`, `'flat-button'`, or `'basic-link'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'basic-link'"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Overrides that will modify the styles sent to `$computedClass` based on `appearance` prop",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "primary",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Show as primary rather than secondary style\n(for `'raised-button'` and `'flat-button'` appearance)",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "href",
        "description": "URL string",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "download",
        "description": "Specifies that the file is meant to be downloaded, not displayed in a separate tab.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "openInNewTab",
        "description": "If provided, opens link in new tab and displays a \"pop out\" icon",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "icon",
        "description": "If provided, shows a KIcon in front of the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "If provided, shows a KIcon after the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "default",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "iconAfter",
        "description": "Slot alternative to the `icon` prop"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/buttons-and-links/KExternalLink.vue",
      "/opt/build/repo/lib/buttons-and-links/buttonMixin.js"
    ]
  },
  "KIconButton": {
    "displayName": "KIconButton",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "icon",
        "description": "Name of icon to display",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "appearance",
        "description": "Button appearance: `'raised-button'` or `'flat-button'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'flat-button'"
        }
      },
      {
        "name": "color",
        "description": "Optional hex or rgb[a] color for the button background",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not button is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "buttonType",
        "description": "HTML button `type` attribute (e.g. `'submit'`, `'reset'`)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'button'"
        }
      },
      {
        "name": "size",
        "description": "Button size: `'mini'`, `'small'`, `'regular'`, or `'large'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'regular'"
        }
      },
      {
        "name": "ariaLabel",
        "description": "`aria-label` attribute",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "tooltip",
        "description": "Tooltip label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "tooltipPosition",
        "description": "Tooltip position: `'top', 'right', 'bottom', 'left'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'bottom'"
        }
      }
    ],
    "slots": [
      {
        "name": "menu"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/buttons-and-links/KIconButton.vue"
    ]
  },
  "KRouterLink": {
    "exportName": "default",
    "displayName": "KRouterLink",
    "description": "KRouterLink creates a styled router-link",
    "tags": {},
    "props": [
      {
        "name": "text",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearance",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button appearance: `'raised-button'`, `'flat-button'`, or `'basic-link'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'basic-link'"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Overrides that will modify the styles sent to `$computedClass` based on `appearance` prop",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "primary",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Show as primary rather than secondary style\n(for `'raised-button'` and `'flat-button'` appearance)",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "to",
        "description": "vue-router link object",
        "type": {
          "name": "object"
        },
        "required": true
      },
      {
        "name": "icon",
        "description": "If provided, shows a `KIcon` with the given name before the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "If provided, shows a `KIcon` with the given name after the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "replace",
        "description": "Use window.history.replaceState() so navigation will not leave history record",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Optional slot as alternative to `icon` prop"
      },
      {
        "name": "default",
        "description": "Optional slot as alternative to `text` prop"
      },
      {
        "name": "iconAfter",
        "description": "Optional slot as alternative to `iconAfter` prop"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/buttons-and-links/KRouterLink.vue",
      "/opt/build/repo/lib/buttons-and-links/buttonMixin.js"
    ]
  },
  "KCard": {
    "displayName": "KCard",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "headingLevel",
        "description": "HTML heading level in range (h2 - h6) for the title",
        "type": {
          "name": "number"
        },
        "required": true
      },
      {
        "name": "to",
        "description": "A Vue route object. If provided, card click\nwill navigate to the target.",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "title",
        "description": "Card title",
        "type": {
          "name": "string"
        },
        "required": true,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "titleMaxLines",
        "description": "Truncates title lines",
        "type": {
          "name": "number"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "2"
        }
      },
      {
        "name": "orientation",
        "description": "Controls card orientation.\nOptions: `'horizontal'`, `'vertical'`.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'horizontal'"
        }
      },
      {
        "name": "thumbnailDisplay",
        "description": "Controls if and how the thumbnail appears in the card.\nOptions: `'none'`, `'small'`, or `'large'`.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'none'"
        }
      },
      {
        "name": "thumbnailSrc",
        "description": "Thumbnail source path.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "thumbnailScaleType",
        "description": "Specifies how the thumbnail scales in the card.\nOptions: `'centerInside'`, `'contain'`, `'fitXY'`.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'centerInside'"
        }
      },
      {
        "name": "thumbnailAlign",
        "description": "Controls the alignment of the thumbnail area\nin horizontal card orientation.\nOptions: `'left'`, `'right'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'left'"
        }
      },
      {
        "name": "preserveAboveTitle",
        "description": "If `aboveTitle` slot is empty, controls\nwhether its space is preserved or not.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "preserveBelowTitle",
        "description": "If `belowTitle` slot is empty, controls\nwhether its space is preserved or not.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "preserveFooter",
        "description": "If `footer` slot is empty, controls\nwhether its space is preserved or not.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "isSkeleton",
        "description": "Private. Do not use.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "click",
        "description": "Emitted when a card is clicked or pressed with enter.\nContains the DOM event in the payload.",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "focus",
        "description": "Emitted when a card gets focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "hover",
        "description": "Emitted when a card is hovered",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "title",
        "scoped": true,
        "description": "A scoped slot via which the `title` can be customized. ",
        "bindings": [
          {
            "name": "titleText",
            "title": "binding"
          }
        ]
      },
      {
        "name": "aboveTitle",
        "description": "Places content to the area above the title."
      },
      {
        "name": "belowTitle",
        "description": "Places content to the area below the title."
      },
      {
        "name": "thumbnailPlaceholder",
        "description": "Places content to the thumbnail placeholder area."
      },
      {
        "name": "footer",
        "description": "Places content to the footer area."
      },
      {
        "name": "select",
        "description": "For selection controls such as checkbox or radio button"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/cards/KCard.vue"
    ]
  },
  "KCardGrid": {
    "displayName": "KCardGrid",
    "description": "Displays a grid of cards `KCard`.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "layout",
        "description": "Sets the base grid layout.\nOptions: `'1-1-1'`, `'1-2-2'`, and `'1-2-3'`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "'1-2-2'"
        }
      },
      {
        "name": "layoutOverride",
        "description": "Overrides the base grid `layout` for chosen breakpoints levels",
        "type": {
          "name": "array"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "loading",
        "description": "Set to `true` as long as data for cards\nare being loaded to display loading skeletons",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "skeletonsConfig",
        "description": "Configures loading skeletons",
        "type": {
          "name": "array"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "debug",
        "description": "Use for development only. Shows information in\nthe grid's corner that is useful for configuring\nloading skeletons.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Slot for `KCard`s"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/cards/KCardGrid.vue"
    ]
  },
  "KFixedGrid": {
    "displayName": "KFixedGrid",
    "description": "Grid layout with a fixed number of columns",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "numCols",
        "description": "The number of columns. Can be an integer between `2` and `12`",
        "type": {
          "name": "number|string"
        },
        "required": true
      },
      {
        "name": "gutter",
        "description": "The size of column gutters in pixels. If not provided, the gutter is set to `16px`\nif either window dimension is less than `600px`, and set to `24px` otherwise.",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "gridStyle",
        "description": "EXPERIMENTAL: Extra styles to attach to the internal grid DOM node",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "debug",
        "description": "Show gridlines for debugging purposes",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Children of a `KFixedGrid` must be `KFixedGridItem` components"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/grids/KFixedGrid.vue"
    ]
  },
  "KFixedGridItem": {
    "displayName": "KFixedGridItem",
    "description": "Basic fixed grid item",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "span",
        "description": "Number of grid columns that the item should span.\n\nIf not provided, the item will span the full width of the grid.",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "alignment",
        "description": "Horizontal alignment of the item's contents. `'left'`, `'right'`,\nand `'center'` will set `text-align`. `'auto'` will set `dir=\"auto\"`\nfor user-generated content to support bidirectional text.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'left'"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Contents of the grid item"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/grids/KFixedGridItem.vue"
    ]
  },
  "KGrid": {
    "displayName": "KGrid",
    "description": "Grid layout with a dynamic number of columns based on the current window width.\n\nThe grid will have 4 columns for small windows (width < 840px), 8 columns\nfor medium windows (840 px <= width < 960), and 12 columns for large windows\n(960px <=  width)",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "gutter",
        "description": "The size of column gutters in pixels. If not provided, the gutter is set to `16px`\nif either window dimension is less than `600px`, and set to `24px` otherwise.",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "gridStyle",
        "description": "EXPERIMENTAL: Extra styles to attach to the internal grid DOM node",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "debug",
        "description": "Show gridlines for debugging purposes",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Children of a `KFixedGrid` must be `KGridItem` components"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/grids/KGrid.vue"
    ]
  },
  "KGridItem": {
    "displayName": "KGridItem",
    "description": "Responsive grid item used with KGrid.\n\nAccepts \"layout objects\" as props, which can define values for 'span',\n'alignment', or both.\n\nIf no span is defined for a particular layout, the item will span the full\nwidth of the grid.\n\nIf no alignment is defined for a particular layout, the item's contents\nwill be left-aligned. Set `alignment` to `'auto'` to set `dir=\"auto\"`\nfor user-generated content to support bidirectional text.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "layout",
        "description": "Default layout object, for all grid sizes",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "layout4",
        "description": "Layout object for small, 4-column layouts",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "layout8",
        "description": "Layout object for medium, 8-column layouts",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "layout12",
        "description": "Layout object for large, 12-column layouts",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Contents of the grid item"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/grids/KGridItem.vue"
    ]
  },
  "KBreadcrumbs": {
    "displayName": "KBreadcrumbs",
    "description": "Used to aid deeply nested navigation of content channels, topics, and resources",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "items",
        "description": "An array of objects, each with a `text` attribute (String) and a\n`link` attribute (vue router link object). The `link` attribute\nof the last item in the array is optional and ignored. The `link`\nattribute can be set to `null` which will render the breadcrumb only\nas text, regardless of its position in the breadcrumb.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "showSingleItem",
        "description": "By default, the breadcrums will be hidden when the length of items is 1.\nWhen set to `true`, a breadcrumb will be shown even when there is only one.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KBreadcrumbs.vue"
    ]
  },
  "KCheckbox": {
    "displayName": "KCheckbox",
    "description": "Used for toggling boolean user input",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "label",
        "description": "Text label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "labelDir",
        "description": "RTL dir of the text label\nOptions: 'auto', 'ltr', 'rtl', null.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'auto'"
        }
      },
      {
        "name": "showLabel",
        "description": "Whether or not to show the label",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "checked",
        "description": "Checked state",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "indeterminate",
        "description": "Indeterminate state. Overrides `checked` state",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "disabled",
        "description": "Disabled state",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "description",
        "description": "Description - subtext to the label",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "keydown"
      },
      {
        "name": "change",
        "description": "Emits change event",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "blur",
        "description": "Emits blur event, useful for validation"
      }
    ],
    "methods": [
      {
        "name": "focus",
        "description": "Sets keyboard focus to the checkbox",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Optional slot as alternative to `label` prop"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KCheckbox.vue"
    ]
  },
  "KDateCalendar": {
    "displayName": "KDateCalendar",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "firstAllowedDate",
        "description": "constrains the selection to after this date, disabling dates prior",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "lastAllowedDate",
        "description": "constrains date selection to before this date, disabling dates after",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "new Date()"
        }
      },
      {
        "name": "selectedStartDate",
        "description": "default value of selected start date",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "selectedEndDate",
        "description": "default value of selected end date",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "previousMonthText",
        "description": "label for previous month button",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "nextMonthText",
        "description": "label for next month button",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "events": [
      {
        "name": "updateSelectedDates",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KDateRange/KDateCalendar.vue"
    ]
  },
  "KDateDay": {
    "displayName": "KDateDay",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "day",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "isSelected",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isInRange",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isDisabled",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isEndOfWeek",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isStartOfWeek",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isLastDay",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "activeMonth",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KDateRange/KDateDay.vue"
    ]
  },
  "KDateInput": {
    "displayName": "KDateInput",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "inputRef",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "legendText",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "errorMessage",
        "type": {
          "name": "string|boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "value",
        "type": {
          "name": "date|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "updateDate",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KDateRange/KDateInput.vue"
    ]
  },
  "KDropdownMenuTest": {
    "displayName": "KDropdownMenuTest",
    "exportName": "default",
    "description": "",
    "tags": {},
    "sourceFiles": [
      "/opt/build/repo/lib/KDropdownMenu/__tests__/components/KDropdownMenuTest.vue"
    ]
  },
  "KEmptyPlaceholder": {
    "displayName": "KEmptyPlaceholder",
    "exportName": "default",
    "description": "",
    "tags": {},
    "sourceFiles": [
      "/opt/build/repo/lib/KEmptyPlaceholder.vue"
    ]
  },
  "KFocusTrap": {
    "displayName": "KFocusTrap",
    "description": "This component ensures that focus moves between the first element\nand the last element of content provided by the default slot.\nIn disabled state, it only renders whatever has been passed\nto the default slot, and doesn't add any focus trap behavior,\nallowing for flexible use from parent components.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "disabled",
        "description": "Disables the focus trap when set to `true`. Focus will behave normally.",
        "tags": {
          "type": [
            {
              "title": "type",
              "type": {
                "name": "Boolean"
              }
            }
          ],
          "default": [
            {
              "description": "false",
              "title": "default"
            }
          ]
        },
        "type": {
          "name": "Boolean"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "shouldFocusFirstEl",
        "description": "Emits an event to notify the parent component to focus the first element."
      },
      {
        "name": "shouldFocusLastEl",
        "description": "Emits an event to notify the parent component to focus the last element."
      }
    ],
    "methods": [
      {
        "name": "reset",
        "description": "Reset the next focus to the first focus element",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Default slot where the focusable content will be rendered"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KFocusTrap.vue"
    ]
  },
  "KLabeledIcon": {
    "displayName": "KLabeledIcon",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "label",
        "description": "Text label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "icon",
        "description": "An icon that will be prepended to the label.\nUses the same icon names as the `KIcon` component",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "An icon that will be appended to the label.\nUses the same icon names as the `KIcon` component",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "color",
        "description": "If provided, sets the color of the label and any icons that are provided",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "maxWidth",
        "description": "Limits label width to this value",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'100%'"
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Optional slot as alternative to `icon` prop"
      },
      {
        "name": "default",
        "description": "Optional slot as alternative to `label` prop"
      },
      {
        "name": "iconAfter",
        "description": "Optional slot as alternative to `iconAfter` prop"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KLabeledIcon.vue"
    ]
  },
  "KListWithOverflow": {
    "displayName": "KListWithOverflow",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "items",
        "description": "An array of items to be shown, the items can be any type of object or primitive, as\nthey are passed to the `#item` slot for rendering.\nThe only special type of item is a divider, which must be an object with a `type`\nproperty set to \"divider\", and this will render the #divider slot.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "appearanceOverrides",
        "description": "An object or string with CSS properties to be applied to the list wrapper",
        "type": {
          "name": "object|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "slots": [
      {
        "name": "divider",
        "scoped": true,
        "description": "Slot for rendering divider items",
        "bindings": [
          {
            "name": "divider",
            "title": "binding"
          }
        ]
      },
      {
        "name": "item",
        "scoped": true,
        "description": "Slot responsible of rendering each item in the visible list",
        "bindings": [
          {
            "name": "item",
            "title": "binding"
          }
        ]
      },
      {
        "name": "more",
        "scoped": true,
        "description": "Slot responsible of rendering the \"see more\" button.",
        "bindings": [
          {
            "name": "overflowItems",
            "title": "binding"
          }
        ]
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KListWithOverflow.vue"
    ]
  },
  "KModal": {
    "displayName": "KModal",
    "description": "Used to focus attention on a singular action/task",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "title",
        "description": "The title of the modal",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "submitText",
        "description": "If provided, text of the submit button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "cancelText",
        "description": "If provided, text of the cancel button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "submitDisabled",
        "description": "Disable the submit button",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "cancelDisabled",
        "description": "Disable the cancel button",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "size",
        "description": "Width of modal. For consistency use the strings `'small'`, `'medium'`, or `'large'`.\nFor more precise control use an integer number of pixels.",
        "type": {
          "name": "string|number"
        },
        "defaultValue": {
          "func": false,
          "value": "'medium'"
        }
      },
      {
        "name": "hasError",
        "description": "Toggles error message indicator in title",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "errorMessage",
        "description": "Error message to be displayed in title",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appendToOverlay",
        "description": "Whether or not the modal should be moved\nto the overlay container element `#k-overlay`",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "cancel",
        "description": "Emitted when the cancel button is clicked or the esc key is pressed"
      },
      {
        "name": "submit",
        "description": "Emitted when the submit button or the enter key is pressed"
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Main content of modal"
      },
      {
        "name": "actions",
        "description": "Alternative buttons and actions below main content"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KModal.vue"
    ]
  },
  "KOptionalText": {
    "displayName": "KOptionalText",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "text",
        "description": "Text to display. If the text is missing or empty, then `KEmptyPlaceholder` will be rendered",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverrides",
        "description": "If provided, sets the styles of the text",
        "type": {
          "name": "object|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Pass sub-components to render, if none of the nodes in the entire node hierarchy"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KOptionalText.vue"
    ]
  },
  "KPageContainer": {
    "displayName": "KPageContainer",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "noPadding",
        "description": "Whether or not to disable internal container padding",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "topMargin",
        "description": "Value in pixels for top margin",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "24"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Contents of the page container"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KPageContainer.vue"
    ]
  },
  "KRadioButton": {
    "displayName": "KRadioButton",
    "description": "Used to display radio buttons.\n\nTo be used within `KRadioButtonGroup`.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "label",
        "description": "Text label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "showLabel",
        "description": "Whether or not to show the label",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "labelDir",
        "description": "RTL dir of the text label\nOptions: 'auto', 'ltr', 'rtl', null.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'auto'"
        }
      },
      {
        "name": "v-model",
        "description": "Component `data` with which to associate this radio button and its siblings",
        "type": {
          "name": "string|number|boolean"
        },
        "required": true
      },
      {
        "name": "buttonValue",
        "description": "Unique value that will be assigned to `v-model` data when this radio button is selected",
        "type": {
          "name": "string|number|boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "value",
        "description": "(DEPRECATED)",
        "type": {
          "name": "string|number|boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "description",
        "description": "If provided, description underneath label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the field is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "autofocus",
        "description": "Whether or not to auto-focus on mount",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "truncateLabel",
        "description": "Whether or not to truncate label",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "keydown",
        "description": "Emitted with `keydown` events",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "change",
        "description": "Emitted on each change with new boolean of button state",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "input",
        "description": "Used to set `buttonValue` to `v-model` when checked",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "description": "Emits blur event, useful for validation"
      }
    ],
    "methods": [
      {
        "name": "toggleCheck",
        "description": "Toggles the check state of the radio button.",
        "params": [
          {
            "name": "event",
            "type": {
              "name": "Event"
            },
            "description": "The event object."
          }
        ],
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ],
          "params": [
            {
              "title": "param",
              "type": {
                "name": "Event"
              },
              "name": "event",
              "description": "The event object."
            }
          ]
        }
      },
      {
        "name": "focus",
        "description": "Puts keyboard focus on the radiobutton",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      },
      {
        "name": "setTabIndex",
        "description": "Sets `tab-index` on input",
        "params": [
          {
            "name": "val"
          }
        ],
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Optional slot as alternative to `label` prop"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KRadioButton.vue"
    ]
  },
  "KRadioButtonGroup": {
    "displayName": "KRadioButtonGroup",
    "description": "Supposed to wrap a `KRadioButton` group.\n\nEnsures radio button groups are accessible\nin all supported browsers by:\n  - Allows movement between radio buttons inside\n    a radio group using arrow keys in Firefox\n    (https://github.com/learningequality/kolibri/issues/10491)",
    "tags": {},
    "exportName": "default",
    "slots": [
      {
        "name": "default",
        "description": "For `KRadioButton`s"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KRadioButtonGroup.vue"
    ]
  },
  "KSelectOption": {
    "displayName": "KSelectOption",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "option",
        "type": {
          "name": "string|object"
        },
        "required": true
      },
      {
        "name": "type",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'basic'"
        }
      },
      {
        "name": "multiple",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "highlighted",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "selected",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "keys",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{\n  label: 'label',\n  image: 'image',\n}"
        }
      }
    ],
    "slots": [
      {
        "name": "default"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KSelect/KSelectOption.vue"
    ]
  },
  "KSwitch": {
    "displayName": "KSwitch",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "ariaLabelledBy",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "value",
        "description": "Current value of the switch state: on or off",
        "type": {
          "name": "boolean"
        },
        "required": true
      },
      {
        "name": "name",
        "description": "does this need to be exposed?",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "label",
        "description": "If provided, show a text label next to the switch",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "tabindex",
        "description": "does this need to be exposed?",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string|number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "trueValue",
        "description": "might not be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "falseValue",
        "description": "might not be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "submittedValue",
        "description": "might not be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'on'"
        }
      },
      {
        "name": "checked",
        "description": "seems redundant with 'value'",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "color",
        "description": "not used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'primary'"
        }
      },
      {
        "name": "switchPosition",
        "description": "not used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'left'"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the switch is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "input",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "description": "Emitted on each change with new `value`",
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "change",
        "description": "does this need to be exposed?",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "tags": [
          {
            "title": "ignore",
            "content": true
          }
        ],
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KSwitch.vue"
    ]
  },
  "KTableGridItem": {
    "displayName": "KTableGridItem",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "content",
        "type": {
          "name": "string|number|boolean|object|array"
        },
        "required": true
      },
      {
        "name": "rowIndex",
        "type": {
          "name": "number"
        },
        "required": true
      },
      {
        "name": "colIndex",
        "type": {
          "name": "number"
        },
        "required": true
      },
      {
        "name": "minWidth",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'auto'"
        }
      },
      {
        "name": "width",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'auto'"
        }
      },
      {
        "name": "textAlign",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "events": [
      {
        "name": "keydown",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          },
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous2>"
          }
        ]
      }
    ],
    "slots": [
      {
        "name": "default",
        "scoped": true,
        "bindings": [
          {
            "name": "content",
            "title": "binding"
          }
        ]
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KTable/KTableGridItem.vue"
    ]
  },
  "KTextTruncator": {
    "displayName": "KTextTruncator",
    "description": "Truncates text to a certain number of lines\nand adds an ellipsis character \"…\"",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "text",
        "description": "Text to be truncated",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "maxLines",
        "description": "Maximum number of lines to be shown",
        "type": {
          "name": "number"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "1"
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KTextTruncator.vue"
    ]
  },
  "UiToolbar": {
    "displayName": "UiToolbar",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "type",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'default'"
        }
      },
      {
        "name": "textColor",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'black'"
        }
      },
      {
        "name": "title",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "brand",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "navIcon",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'menu'"
        }
      },
      {
        "name": "removeNavIcon",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "raised",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "progressPosition",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'bottom'"
        }
      },
      {
        "name": "loading",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "nav-icon-click"
      }
    ],
    "slots": [
      {
        "name": "icon"
      },
      {
        "name": "brand"
      },
      {
        "name": "default"
      },
      {
        "name": "navigation",
        "scoped": true,
        "bindings": [
          {
            "name": "class",
            "title": "binding"
          }
        ]
      },
      {
        "name": "actions"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KToolbar.vue"
    ]
  },
  "KTransition": {
    "displayName": "KTransition",
    "description": "Exposes predefined set of transitions\nbuilt on top of Vue's <transition>",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "kind",
        "description": "Transition kind. Can be one of:\n`'component-fade-out-in'`.",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "slots": [
      {
        "name": "default"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KTransition.vue"
    ]
  },
  "KCircularLoader": {
    "displayName": "KCircularLoader",
    "description": "Used to show indeterminate loading",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "type",
        "description": "One of `'determinate'` or `'indeterminate'`.\nDeterminate loaders represent a known completion percentage.\nIndeterminate loaders simply show that activity is currently happening.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'indeterminate'"
        }
      },
      {
        "name": "shouldShow",
        "description": "Whether the loader should be displayed or not.\nIt needs to be used instead of `v-if/v-show` for `minVisibleTime` to work.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "progress",
        "description": "For determinate loaders, value between 0 and 100 representing percentage completion",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "0"
        }
      },
      {
        "name": "delay",
        "description": "Whether there should be a delay before the loader displays.\nUseful if the action often takes less than a second or two.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "minVisibleTime",
        "description": "Do not hide the loader until `minVisibleTime` in milliseconds.\nUseful to avoid jarring UX when the actions finishes very fast.\nIn comparison to `delay`, `minVisibleTime` emphasizes that an\naction associated with the loader is indeed taking place.\n`shouldShow` prop needs to be used instead of `v-if/v-show` for this to work.",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "0"
        }
      },
      {
        "name": "size",
        "description": "Overall size of the loader in pixels",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "32"
        }
      },
      {
        "name": "stroke",
        "description": "Stroke width of the loader in pixels",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "4"
        }
      },
      {
        "name": "disableDefaultTransition",
        "description": "Disables the default fade transition. Disabling is suitable when using\na loader in tandem with another component (e.g. as part of v-if/v-else)\nas we typically need to wrap both components in a single transition.\nHaving a loader wrapped by its own transition can cause glitches in\nsuch situations.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/loaders/KCircularLoader.vue"
    ]
  },
  "KLinearLoader": {
    "displayName": "KLinearLoader",
    "description": "Used to show determinate or indeterminate loading",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "type",
        "description": "One of `'determinate'` or `'indeterminate'`.\nDeterminate loaders represent a known completion percentage.\nIndeterminate loaders simply show that activity is currently happening.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'indeterminate'"
        }
      },
      {
        "name": "progress",
        "description": "For determinate loaders, value between 0 and 100 representing percentage completion",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "0"
        }
      },
      {
        "name": "delay",
        "description": "Whether there should be a delay before the loader displays.\nUseful if the action often takes less than a second or two.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/loaders/KLinearLoader.vue"
    ]
  },
  "KTabs": {
    "exportName": "default",
    "displayName": "KTabs",
    "description": "Displays tabs.",
    "tags": {},
    "props": [
      {
        "name": "tabs",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "An array of tab objects `{ id, label, to }` where `id` and `label`\nproperties are required and `to` is optional.\nWhen `to` is provided, tabs render as router links.\nOtherwise, they render as buttons.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "ariaLabel",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "A label that describes the purpose of the set of tabs.\nProviding either `ariaLabel` or `ariaLabelledBy`\nis required.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "ariaLabelledBy",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "ID reference to a DOM element which provides a label\nthat describes the purpose of the set of tabs.\nProviding either `ariaLabel` or `ariaLabelledBy`\nis required.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "color",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs text color.\nDefaults to `$themeTokens.annotation`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "colorActive",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Text color of an active tab.\nDefaults to `$themeTokens.primary`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "backgroundColor",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs background color.\nDefaults to `$themeTokens.surface`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "hoverBackgroundColor",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs hover background color.\nDefaults to `$themeBrand.primary.v_100`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs styles that complement or override default styles\nor styles defined via props (will be sent to `$computedClass`,\nwhich means that styles that are accepted by `$computedClass`,\ne.g. pseudo-classes, are supported)",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverridesActive",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "An active tab styles that complement or override default styles\nor styles defined via props (will be sent to `$computedClass`,\nwhich means that styles that are accepted by `$computedClass`,\ne.g. pseudo-classes, are supported)",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "enablePrint",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tab list items are hidden when printing by default.\n`enablePrint` set to `true` makes them visible in print mode.",
        "type": {
          "name": "boolean"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "tabsId",
        "description": "An ID of a tabbed interface represented\nby this component.\nNeeds to be be unique in regards to all\ntabbed interfaces rendered on one page.",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "events": [
      {
        "name": "error",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Emitted with an error when a misconfiguration error occurs, if a listener is attached",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "tab",
        "scoped": true,
        "description": "Optional slot for tab labels. Exposes `tab` object and `isActive` boolean.",
        "bindings": [
          {
            "name": "tab",
            "title": "binding"
          },
          {
            "name": "isActive",
            "title": "binding"
          }
        ]
      },
      {
        "name": "default",
        "description": "An alternative to using slots named by tabs' IDs."
      },
      {
        "name": "slot",
        "scoped": true,
        "bindings": [
          {
            "name": "name",
            "title": "binding"
          }
        ]
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/tabs/KTabs.vue",
      "/opt/build/repo/lib/tabs/tabsMixin.js"
    ]
  },
  "KTabsList": {
    "exportName": "default",
    "displayName": "KTabsList",
    "description": "Displays the tab list of a tabbed interface.\nIt is meant to be used together with `KTabsPanel`.\nTabs can be buttons or router links.\n\nTabs are implemented to be manually activated as described in\nhttps://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-manual.html",
    "tags": {},
    "props": [
      {
        "name": "tabs",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "An array of tab objects `{ id, label, to }` where `id` and `label`\nproperties are required and `to` is optional.\nWhen `to` is provided, tabs render as router links.\nOtherwise, they render as buttons.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "ariaLabel",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "A label that describes the purpose of the set of tabs.\nProviding either `ariaLabel` or `ariaLabelledBy`\nis required.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "ariaLabelledBy",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "ID reference to a DOM element which provides a label\nthat describes the purpose of the set of tabs.\nProviding either `ariaLabel` or `ariaLabelledBy`\nis required.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "color",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs text color.\nDefaults to `$themeTokens.annotation`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "colorActive",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Text color of an active tab.\nDefaults to `$themeTokens.primary`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "backgroundColor",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs background color.\nDefaults to `$themeTokens.surface`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "hoverBackgroundColor",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs hover background color.\nDefaults to `$themeBrand.primary.v_100`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs styles that complement or override default styles\nor styles defined via props (will be sent to `$computedClass`,\nwhich means that styles that are accepted by `$computedClass`,\ne.g. pseudo-classes, are supported)",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverridesActive",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "An active tab styles that complement or override default styles\nor styles defined via props (will be sent to `$computedClass`,\nwhich means that styles that are accepted by `$computedClass`,\ne.g. pseudo-classes, are supported)",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "enablePrint",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tab list items are hidden when printing by default.\n`enablePrint` set to `true` makes them visible in print mode.",
        "type": {
          "name": "boolean"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "tabsId",
        "description": "An ID of a tabbed interface that this component is part of.\nNeeds to be be unique in regards to all tabbed interfaces\nrendered on one page.",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "v-model",
        "description": "An ID of an active tab.",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "events": [
      {
        "name": "error",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Emitted with an error when a misconfiguration error occurs, if a listener is attached",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "activate",
        "description": "Emitted when a tab is activated. Its payload is the active tab ID.",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "click",
        "description": "Emitted when a tab is clicked. Its payload is the active tab ID.\nWhen compared to the `activate` event, `click` is emitted only when\na user is interacting with tabs, whereas `activate` can be emitted\nprogramatically in addition to user interaction.",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "methods": [
      {
        "name": "focusActiveTab",
        "description": "Puts focus on the active tab",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "tab",
        "scoped": true,
        "description": "Optional slot for tab labels. Exposes `tab` object and `isActive` boolean.",
        "bindings": [
          {
            "name": "tab",
            "title": "binding"
          },
          {
            "name": "isActive",
            "title": "binding"
          }
        ]
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/tabs/KTabsList.vue",
      "/opt/build/repo/lib/tabs/tabsMixin.js"
    ]
  },
  "KTabsPanel": {
    "displayName": "KTabsPanel",
    "description": "A part of a tabbed interface that displays\ncontent associated with the active tab.\nIt is meant to be used together with `KTabsList`.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "tabsId",
        "description": "An ID of a tabbed interface that this component is part of.\nNeeds to be be unique in regards to all tabbed interfaces\nrendered on one page.",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "activeTabId",
        "description": "An ID of an active tab.",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "An alternative to using slots named by tabs' IDs."
      },
      {
        "name": "[activeTabId]",
        "scoped": true,
        "description": "Slots named by tab's IDs.",
        "bindings": [
          {
            "name": "name",
            "title": "binding"
          }
        ]
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/tabs/KTabsPanel.vue"
    ]
  },
  "KDateRange": {
    "displayName": "KDateRange",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "firstAllowedDate",
        "description": "Constrains the selection to after this date, disabling dates prior",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "lastAllowedDate",
        "description": "Constrains date selection to before this date, disabling dates after",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "new Date()"
        }
      },
      {
        "name": "defaultStartDate",
        "description": "Default value of start date",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "defaultEndDate",
        "description": "Default value of end date",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": true,
          "value": "function() {\n  return startOfToday();\n}"
        }
      },
      {
        "name": "submitText",
        "description": "Submission text of modal",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "cancelText",
        "description": "Cancellation text of modal",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "title",
        "description": "Title of modal",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "description",
        "description": "Description of modal",
        "type": {
          "name": "string|null"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "startDateLegendText",
        "description": "Start date input label",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "endDateLegendText",
        "description": "End date input label",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "previousMonthText",
        "description": "label for previous month button",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "nextMonthText",
        "description": "label for next month button",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "events": [
      {
        "name": "cancel"
      },
      {
        "name": "submit",
        "description": "Emitted when the submit button or the enter key is pressed",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "description",
        "description": "Description of modal"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KDateRange/index.vue"
    ]
  },
  "KDropdownMenu": {
    "displayName": "KDropdownMenu",
    "description": "The KDropdownMenu component is used to contain multiple actions",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "constrainToScrollParent",
        "description": "The dropdown menu popover flips its position to avoid overflows within the parent.\nSetting it to false disables the flipping behavior.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "options",
        "description": "An array of options objects, with one object per dropdown item",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "hasIcons",
        "description": "Whether or not the options display an icon",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "maxWidth",
        "description": "Maximum width for the dropdown menu",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "position",
        "description": "The position of the dropdown relative to the button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'bottom right'"
        },
        "values": [
          "bottom left",
          "bottom center",
          "bottom right",
          "top left",
          "top center",
          "top right",
          "left top",
          "left middle",
          "left bottom",
          "right top",
          "right middle",
          "right bottom"
        ]
      },
      {
        "name": "isContextMenu",
        "description": "Whether or not the dropdown is a context menu, if true, the dropdown will open when\nthe user right-clicks the parent element",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "tab",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "select",
        "description": "Emitted when an option is selected",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "close"
      }
    ],
    "slots": [
      {
        "name": "header"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KDropdownMenu/index.vue"
    ]
  },
  "KIcon": {
    "displayName": "KIcon",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "icon",
        "description": "Icon token identifier",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "color",
        "description": "Color to apply to the icon",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disableColor",
        "description": "Don't apply automatic fill, allowing external styling.\nCurrently used by the design system itself. Not exposed until we see a broader need",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KIcon/index.vue"
    ]
  },
  "KImg": {
    "displayName": "KImg",
    "description": "Displays an image and provides additional functionality\nto manipulate it such as setting an aspect ratio,\nscaling, and more.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "src",
        "description": "Sets the image path",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "altText",
        "description": "Alternative text for the image. Required unless `isDecorative` is true.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "isDecorative",
        "description": "Sets the image as decorative.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "aspectRatio",
        "description": "Sets the ratio of the width(w) to the height(h)\nof the image container. The required format is `w:h`.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "scaleType",
        "description": "Specifies how an image should be scaled within the container.\nCan be one of  `'centerInside'`, `'contain'`, or `'fitXY'`.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'centerInside'"
        }
      },
      {
        "name": "backgroundColor",
        "description": "A color to be displayed instead or behind an image.\nIt creates a background area which respects the dimensions\nset on the image container.\n\nIt can serve as (1) a color of the area surrounding an image when\nit's letterboxed, (2) a placeholder area displayed\nover the whole container when an image source is not provided,\n(3) a progressive loading experience as the colored background\nis displayed while an image is loading.\n\nIts default value is `$themePalette.grey.v_100`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "borderRadius",
        "description": "The border radius of the image container or the placeholder area",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverrides",
        "description": "A dynamic style object that overrides the default styles",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      }
    ],
    "events": [
      {
        "name": "error",
        "description": "Emitted when the image fails to load or a misconfiguration error occurs.\nExpect either an `Event` or `Error`",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "load",
        "description": "Emitted when the image loads successfully. The DOM event is available in the payload.",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "placeholder",
        "description": "Places content to the placeholder area."
      },
      {
        "name": "topLeft",
        "description": "Places content on top of an image, to its top left corner."
      },
      {
        "name": "topRight",
        "description": "Places content on top of an image, to its top right corner."
      },
      {
        "name": "bottomLeft",
        "description": "Places content on top of an image, to its bottom left corner."
      },
      {
        "name": "bottomRight",
        "description": "Places content on top of an image, to its bottom right corner."
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KImg/index.vue"
    ]
  },
  "KLogo": {
    "displayName": "KLogo",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "altText",
        "description": "Alternative text for the logo",
        "type": {
          "name": "string"
        },
        "required": true,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "size",
        "description": "Sets the size for the logo",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "maxSize",
        "description": "Sets the maximum size for the logo",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "minSize",
        "description": "Sets the minimum size for the logo",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "showBackground",
        "description": "Whether to show the blob background for the logo",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "backgroundStyle",
        "description": "The background style for the logo: blob, rect",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'blob'"
        },
        "values": [
          "blob",
          "rect"
        ]
      },
      {
        "name": "colorScheme",
        "description": "The color scheme for the logo:\ndefault, monoBlack, monoWhite, monoPrimary, monoSecondary, whiteGrey, blackGrey",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'default'"
        }
      },
      {
        "name": "animate",
        "description": "Whether to show the loading animation for the logo - only works for non-mono colorSchemes",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KLogo/index.vue"
    ]
  },
  "KOverlay": {
    "displayName": "KOverlay",
    "description": "Moves an element from its original place in the DOM\nto the overlay container element #k-overlay that is inserted\nto an application's document body automatically during\nthe KDS installation process (see KThemePlugin.js).\nThis is often useful for modals, tooltips, dropdowns, or other\nelements that should appear on top of other content.",
    "tags": {},
    "exportName": "default",
    "slots": [
      {
        "name": "default",
        "description": "Content to be moved to the overlay container element `#k-overlay`"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KOverlay/index.vue"
    ]
  },
  "KSelect": {
    "displayName": "KSelect",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "value",
        "description": "Object currently selected",
        "type": {
          "name": "object"
        },
        "required": true
      },
      {
        "name": "options",
        "description": "Array of option objects { value, label, disabled }.\nDisabled key is optional",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "placeholder",
        "description": "Sets the placeholder value",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "label",
        "description": "Specifies the label text. Default is  empty  if not provided.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "floatingLabel",
        "description": "Floating Label",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "multiple",
        "description": "Whether multiple options can be selected or not",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "multipleDelimiter",
        "description": "Delimiter for multiple selected options",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "', '"
        }
      },
      {
        "name": "noResultsText",
        "description": "Text displayed if no results",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "keys",
        "description": "Object that defines the label, value and image keys in objects of the `options` prop.\nDefault: { label: 'label', value: 'value', image: 'image' }",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "config.data.UiSelect.keys"
        }
      },
      {
        "name": "invalid",
        "description": "Whether invalid or not",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "invalidText",
        "description": "Text displayed if invalid",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "help",
        "description": "Help text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disabled",
        "description": "Whether disabled or not",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "clearable",
        "description": "Whether to turn into a clearable state\nwhen an option has been selected.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "clearText",
        "description": "Defines the tooltip and aria-label of the clear button if the select is clearable.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "inline",
        "description": "Whether or not display as inline block",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "query-change",
        "description": "Emits whenever the query value changes.",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "change",
        "description": "Emitted when the value is changed",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "input",
        "description": "Emits an 'input' event with the new value when the selection is updated.",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "select",
        "description": "Emitted when an option is selected by the user. Will not be emitted if the selection is\nchanged programmatically.",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "focus",
        "description": "Emitted when the select gets focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "description": "Emitted when the select loses focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "dropdown-open"
      },
      {
        "name": "touch"
      },
      {
        "name": "dropdown-close"
      }
    ],
    "methods": [
      {
        "name": "reset",
        "description": "Resets the selected values of dropdown",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Optional slot as alternative to `label` prop"
      },
      {
        "name": "display",
        "description": "Optional slot to override the display of the selected value"
      },
      {
        "name": "option",
        "scoped": true,
        "description": "Optional slot to override the display of",
        "bindings": [
          {
            "name": "highlighted",
            "title": "binding"
          },
          {
            "name": "index",
            "title": "binding"
          },
          {
            "name": "option",
            "title": "binding"
          },
          {
            "name": "selected",
            "title": "binding"
          }
        ]
      },
      {
        "name": "no-results",
        "description": "Optional slot as alternative to `noResultsText` prop"
      },
      {
        "name": "error",
        "description": "Optional slot as alternative to `invalidText` prop"
      },
      {
        "name": "help",
        "description": "Optional slot as alternative to `help` prop"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KSelect/index.vue"
    ]
  },
  "KTable": {
    "displayName": "KTable",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "headers",
        "description": "An array of objects:\n`{ label, dataType, minWidth, width, columnId }`\nrepresenting the headers of the table.\nThe `dataType` can be one of `'string'`, `'number'`, `'date'`, or `'undefined'`.\n`label` and `dataType` are required. `minWidth` and `width` are optional.\n`columnId` is an unique identifier for the column, and can be a `number` or a `string`.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "rows",
        "description": "An array of arrays representing the rows of the table.\nEach row should have the same number of elements as the headers array.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "caption",
        "description": "The caption of the table",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "sortable",
        "description": "Enables or disables sorting functionality for the table headers.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "emptyMessage",
        "description": "The message to display when the table is empty.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'No data available'"
        }
      },
      {
        "name": "dataLoading",
        "description": "Indicates whether the data is currently being loaded.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "defaultSort",
        "description": "Indicates whether the table is to be sorted by default by any header or not.\nBy default it is an empty object which means no default sorting is to be used.\nIt accepts a configuration object `{ columnId, direction }`.\n`columnId` references a `columnId` defined for a header in `headers`.\nThis specifies a column by which the table should be sorted when initially loaded.\n`direction` can be `'asc'` for ascending or `'desc'` for descending sort direction.",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "disableBuiltinSorting",
        "description": "Disables built-in sort function.\nThis is useful when you want to define your own sorting logic.\nRefer to the examples above for more details.",
        "type": {
          "name": "boolean"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "header",
        "scoped": true,
        "description": "Scoped slot for customizing the content of each header cell.",
        "bindings": [
          {
            "name": "header",
            "title": "binding"
          },
          {
            "name": "colIndex",
            "title": "binding"
          }
        ]
      },
      {
        "name": "cell",
        "scoped": true,
        "description": "Scoped slot for customizing the content of each data cell.",
        "bindings": [
          {
            "name": "content",
            "title": "binding"
          },
          {
            "name": "rowIndex",
            "title": "binding"
          },
          {
            "name": "colIndex",
            "title": "binding"
          },
          {
            "name": "row",
            "title": "binding"
          }
        ]
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KTable/index.vue"
    ]
  },
  "KTextbox": {
    "displayName": "KTextbox",
    "description": "Handles user input.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "label",
        "description": "Label for the text field",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "clearAriaLabel",
        "description": "Value of the aria-label for clear button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'Clear'"
        }
      },
      {
        "name": "value",
        "description": "Value of the text field",
        "type": {
          "name": "string|number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "invalid",
        "description": "Whether or not the current `value` is invalid",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "invalidText",
        "description": "Text conditionally displayed based on values of `invalid` and `showInvalidText`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "showInvalidText",
        "description": "Show the `invalidText` even if the user has not focused or change the input.\n`invalid` must also be `true` for this to take effect.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the field is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "autofocus",
        "description": "Whether or not to autofocus",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "maxlength",
        "description": "Maximum number of characters for `value`",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "autocomplete",
        "description": "HTML5 autocomplete attribute (`off`, `on`, `name`, `username`, `current-password`, etc)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "autocapitalize",
        "description": "HTML5 autocapitalize attribute. Used for touch-input enabled UI (`off`, `on`, `words`, etc)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "type",
        "description": "HTML5 type of input (`text`, `password`, `number`, etc.)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'text'"
        }
      },
      {
        "name": "min",
        "description": "Minimum value (when `value` type is `number`)",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "max",
        "description": "Maximum value (when `value` type is `number`)",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "textArea",
        "description": "Whether to display as a multi-line text area",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "clearable",
        "description": "When set to `true`, the component displays a clear button inside the input field.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "floatingLabel",
        "description": "Whether or not to display as a floating label.\nThis should not actually be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      }
    ],
    "events": [
      {
        "name": "input",
        "description": "Emitted on each change with new `value`",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "keydown",
        "description": "Emitted with `keydown` events",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "methods": [
      {
        "name": "focus",
        "description": "Puts keyboard focus in the text field",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KTextbox/index.vue"
    ]
  },
  "KTooltip": {
    "displayName": "KTooltip",
    "description": "Used to create a tooltip.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "reference",
        "description": "Name of `ref` element within the parent's `$refs` object. Tooltip will be\npositioned relative to this element.",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "refs",
        "description": "Parent's `$refs` object which should contain the named `reference`.",
        "type": {
          "name": "object"
        },
        "required": true
      },
      {
        "name": "disabled",
        "description": "Whether or not tooltip is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "placement",
        "description": "Placement of tooltip relative to `reference`. Supports any _popper.js_ placement string",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'bottom'"
        }
      },
      {
        "name": "text",
        "description": "Text of the tooltip",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "maxWidth",
        "description": "Maximum width of the tooltip.\nAccepted values follow the standard\nCSS max-width property format.\nIf it's not provided, the tooltip's\nsize fits its content.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appendToOverlay",
        "description": "Whether or not the tooltip should be moved\nto the overlay container element `#k-overlay`",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Slot alternative to `text` prop"
      }
    ],
    "sourceFiles": [
      "/opt/build/repo/lib/KTooltip/index.vue"
    ]
  }
}